import React, { useReducer } from "react";
import { reducer } from "./reducer";
import { useImmerReducer } from "use-immer";

type ContextValue = [any, (params: any) => void];

export interface ContextState {
  draggable?: {
    originalX: number;
    originalY: number;
    width: number;
    height: number;
    offsetX: number;
    offsetY: number;
  };
  droppableId: string;
  droppables: Array<any>;
}

export const DragDropContext = React.createContext<ContextValue>([
  {},
  () => {},
]);

interface Props {}

const DragDropProvider: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const [state, dispatch] = useImmerReducer(reducer, {
    draggable: undefined,
    droppableId: undefined,
    droppables: {},
    draggables: {},
  });

  return (
    <DragDropContext.Provider value={[state, dispatch]}>
      {props.children}
      {/* {process.env.NODE_ENV === "development" && (
        <pre
          style={{
            overflowWrap: "break-word",
            width: "500px",
          }}
        >
          {JSON.stringify(state, null, 2)}
        </pre>
      )} */}
    </DragDropContext.Provider>
  );
};

export default DragDropProvider;
